module.exports = __webpack_public_path__ + "assets/a049dcb5d053bd986afccb9d4322b9ae.mp3";